const EventBus = window.EventBus;

// After appending a page, wait this long before re-checking whether the scroll
// sentinel is still in view and another page is needed. Kept short: a shopper
// flicking through a page faster than this would otherwise sit at the footer
// watching the spinner until the interval runs out.
const SCROLL_LOAD_INTERVAL = 300;

// Treat the sentinels as "in view" this far below the viewport, so the next
// page is appended while the shopper is still scrolling through the current
// one instead of only once they hit the footer.
const SCROLL_PREFETCH_MARGIN = '0px 0px 1500px 0px';

// The footer is not always in the DOM when this component mounts, so retry
// attaching the observer instead of re-querying on every scroll event.
const SENTINEL_RETRY_INTERVAL = 500;
const SENTINEL_RETRY_LIMIT = 10;

// Cards are never removed once appended, and each one costs ~100 DOM nodes and
// ~3 Vue components. Left unattended at the bottom of the page infinite scroll
// would append the entire feed (1000+ vehicles on the larger stores, ~100k DOM
// nodes, GBs of renderer memory). Stop auto-appending at this many results and
// hand off to the "View More Vehicles" button so further growth is deliberate.
const SCROLL_AUTO_LOAD_MAX_ITEMS = 300;

export const SpaInventory = {
  props: ['ipp', 'currentPageProp', 'urlParams', 'gutembergOptions', 'contentdir', 'loadMore', 'loadMoreBtn','imagesForModels', 'slick', 'paymentFrequency', 'instanceId', 'listingEntries', 'listingConfig'],
  data() {
    return {
      initialInventory: [],
      stockNumber: null,
      priceRange: [],
      mileageRange: [],
      dryweightRange: [],
      grossweightRange: [],
      sleepcapacityRange: [],
      carprooflinkRange: [],
      filterValue: "",
      selected: {},
      inventory: [],
      currentPage: this.currentPageProp,
      loading: false,
      lMore: this.loadMore,
      lMoreBtn: this.loadMoreBtn,
      modelSelected: null,
      i: 1,
      displayMoreBtn: true,
      appendingPage: false,
      lastFilterPayload: null,
    }
  },
created() {
      // Register this instance in the global counter
      EventBus.inventoryInstanceCount++;
      this.httpRequestInventory();
},
mounted() {
    EventBus.$on('goToCompare', this.goToCompare);
    // Listen to instance-specific event if instanceId exists
    if (this.instanceId) {
      EventBus.$on('filterInventory_' + this.instanceId, this.filterInventory);
    } else {
      EventBus.$on('filterInventory', this.filterInventory);
    }
    EventBus.$on('goToPage', this.goToPage);
    EventBus.$on('sortInventory', this.sortInventory);
    this.scroll();

    // Activate Slick if its the case
    if(this.slick){
      setTimeout(() => {
       jQuery("[class*='lbx-inventory-container'].lbx-slick-act")
         .not(".slick-initialized")
         .slick({
           dots: false,
           infinite: true,
           speed: 500,
           slidesToShow: 4,
           slidesToScroll: 1,
           responsive: [
             { breakpoint: 1650, settings: { slidesToShow: 3, dots: false } },
             { breakpoint: 1280, settings: { slidesToShow: 2, dots: false } },
             { breakpoint: 1024, settings: { slidesToShow: 1, dots: false } },
           ],
         });
      }, 500);
    }
  },
  beforeDestroy() {
    if (this.scrollObserver) {
      this.scrollObserver.disconnect();
      this.scrollObserver = null;
    }
    clearTimeout(this.loadNextPageTimer);
    clearTimeout(this.sentinelRetryTimer);
  },
  methods: {
    scroll() {
      if (this.lMore)
        this.observeScrollSentinels();
    },
    // One observer for the lifetime of the component. An IntersectionObserver
    // already reacts to scrolling on its own, so no scroll handler is needed:
    // creating one per scroll event left thousands of live observers behind.
    observeScrollSentinels(attempt) {
      attempt = attempt || 1;

      var targets = [];
      ['.footer', '#lbx-scroll-div'].forEach(selector => {
        document.querySelectorAll(selector).forEach(target => targets.push(target));
      });

      if (!targets.length) {
        if (attempt < SENTINEL_RETRY_LIMIT) {
          this.sentinelRetryTimer = setTimeout(
            () => this.observeScrollSentinels(attempt + 1),
            SENTINEL_RETRY_INTERVAL
          );
        }
        return;
      }

      this.visibleSentinels = new Set();

      this.scrollObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0)
            this.visibleSentinels.add(entry.target);
          else
            this.visibleSentinels.delete(entry.target);
        });
        this.loadNextPage();
      }, { rootMargin: SCROLL_PREFETCH_MARGIN });

      targets.forEach(target => this.scrollObserver.observe(target));
    },
    loadNextPage() {
      clearTimeout(this.loadNextPageTimer);

      // Every bail-out clears the spinner, so it can never stick on: scrolled away
      // from the bottom, nothing left to append, or the auto-load cap reached.
      if (!this.visibleSentinels || !this.visibleSentinels.size) { this.appendingPage = false; return; }
      if (this.currentPage * this.ipp >= this.inventory.length) { this.appendingPage = false; return; }
      if (this.autoLoadCapReached) { this.appendingPage = false; return; }

      // Another page is coming. What the spinner actually covers is the pacing
      // interval below: the records are already in memory, so appending a page is
      // a slice plus a render, never a request.
      this.appendingPage = true;

      // Pacing is driven by a timestamp rather than an in-flight flag: a flag
      // left stuck at true (deferred timer in a background tab) would block
      // loading permanently.
      var elapsed = Date.now() - (this.lastPageLoadedAt || 0);

      if (elapsed < SCROLL_LOAD_INTERVAL) {
        this.loadNextPageTimer = setTimeout(() => this.loadNextPage(), SCROLL_LOAD_INTERVAL - elapsed);
        return;
      }

      this.lastPageLoadedAt = Date.now();
      this.i = this.i + 1;
      this.goToPage(this.i);

      // If the sentinel is still visible after rendering, the page did not grow
      // enough to push it out of view, so keep loading.
      this.loadNextPageTimer = setTimeout(() => this.loadNextPage(), SCROLL_LOAD_INTERVAL);
    },
    showMore() {
      // Also drives the button infinite scroll falls back to once it has
      // auto-appended SCROLL_AUTO_LOAD_MAX_ITEMS results.
      if (this.lMoreBtn || this.lMore) {
        this.i = this.i + 1;
        this.goToPage(this.i);
      }
    },

    httpRequestInventory() {
      this.loading = true;
      EventBus.httpRequestInventory(this.contentdir, this.entryPoint, this.gutembergOptions);
    },
    entryPoint(inventory) {
      // Vehicle records are read-only once they get here: EventBus hands every
      // instance its own deep clone. Freezing them makes Vue skip the whole
      // subtree instead of installing reactive getters on 75 properties across
      // 1000+ vehicles, twice (initialInventory and the filtered inventory).
      // Only the records are frozen, so sortInventory can still sort in place.
      for (var v = 0; v < inventory.length; v++) {
        Object.freeze(inventory[v]);
      }

      this.initialInventory = inventory;
      if (this.urlParams.sort_by_condition) {
        this.sortInventory({ 
          field: this.urlParams.sort_by, 
          order: this.urlParams.sort_by_condition,          
          fieldSecondary: this.urlParams.sort_by_secondary,
          orderSecondary: this.urlParams.sort_order_secondary 
        });
      }else if(this.urlParams.sort_by === "make (custom)"){
        this.sortInventory({ 
          field: "make (custom)", 
          order: this.urlParams.order,
          fieldSecondary: this.urlParams.sort_by_secondary,
          orderSecondary: this.urlParams.sort_order_secondary 
        });
      }else if(this.urlParams.sort_by === "model (custom)"){
        this.sortInventory({ 
          field: "model (custom)", 
          order: this.urlParams.order,
          fieldSecondary: this.urlParams.sort_by_secondary,
          orderSecondary: this.urlParams.sort_order_secondary 
        });
      }else if(this.urlParams.sort_by === "location(custom)"){
        this.sortInventory({ 
          field: "location (custom)", 
          order: this.urlParams.order,
          fieldSecondary: this.urlParams.sort_by_secondary,
          orderSecondary: this.urlParams.sort_order_secondary 
        });
      }else if(this.gutembergOptions.sort_by === "price" && this.gutembergOptions.sort_by_condition === 'asc'){
        this.sortInventory({ 
          field: "price", 
          order: 'asc',
          fieldSecondary: this.urlParams.sort_by_secondary,
          orderSecondary: this.urlParams.sort_order_secondary 
        });
      }
      this.filterInventory(this.computedParams);
      this.loading = false;
    },
    sortInventory(payload) {
      // Helper to check if a vehicle's location is in the priority list
      const isPriorityLocation = (vehicleLocation) => {
        if (this.gutembergOptions.sort_by !== 'location (custom)') return null;
        
        const priorityLocations = this.gutembergOptions.sort_locations;
        if (!priorityLocations || priorityLocations === 'all') return null;
        
        // Handle both string and array formats
        const locations = Array.isArray(priorityLocations) 
          ? priorityLocations 
          : priorityLocations.split(',').map(loc => loc.trim());
        
        if (!vehicleLocation) return false;
        
        const isMatch = locations.some(loc => 
          vehicleLocation.toLowerCase().trim() === loc.toLowerCase().trim()
        );
        
        return isMatch;
      };
      
      // Wrapper to apply location priority to any comparator function
      const withLocationPriority = (compareFn) => {
        return (a, b) => {
          const aIsPriority = isPriorityLocation(a.location);
          const bIsPriority = isPriorityLocation(b.location);
          
          // If location priority is active and one is priority, other isn't
          if (aIsPriority !== null && aIsPriority !== bIsPriority) {
            return aIsPriority ? -1 : 1;
          }
          
          // Otherwise use the original comparator
          return compareFn(a, b);
        };
      };

      // LBT-1453: stocknumber (custom) promotes the dealer-defined stocks to the top
      // (in list order); the rest of the inventory follows, sorted by the dealer's
      // secondary sort (fallback: natural stocknumber asc). Sorted here directly so
      // it bypasses the make/model/location custom-sort pipelines.
      if (payload.field === 'stocknumber (custom)' || payload.field === 'stocknumber_custom') {
        let orderArr = this.gutembergOptions.sort_stocks;
        if (!Array.isArray(orderArr) || orderArr.length === 0) {
          let stockCsv = this.gutembergOptions.stock;
          if (typeof stockCsv === 'string' && stockCsv && stockCsv !== 'all') {
            orderArr = stockCsv.split(',').map(s => s.trim()).filter(Boolean);
          } else {
            orderArr = [];
          }
        }
        let positions = {};
        orderArr.forEach((s, i) => { positions[s] = i; });
        let dir = (payload.order === 'desc') ? -1 : 1;

        let inList = [];
        let outList = [];
        this.initialInventory.forEach(v => {
          if (v && v.stocknumber != null && (v.stocknumber in positions)) {
            inList.push(v);
          } else {
            outList.push(v);
          }
        });
        inList.sort((a, b) => {
          let pa = positions[a.stocknumber];
          let pb = positions[b.stocknumber];
          if (pa === pb) return 0;
          return pa < pb ? -dir : dir;
        });

        const naturalFields = ['stocknumber', 'vin'];
        const secField = (this.gutembergOptions.sort_by_secondary && this.gutembergOptions.sort_by_secondary !== 'none') ? this.gutembergOptions.sort_by_secondary : 'stocknumber';
        const secOrder = (this.gutembergOptions.sort_by_secondary && this.gutembergOptions.sort_by_secondary !== 'none') ? (this.gutembergOptions.sort_by_condition_secondary || 'desc') : 'asc';
        const secNatural = naturalFields.indexOf(secField) !== -1;
        outList.sort((a, b) => {
          let av = a[secField];
          let bv = b[secField];
          if (secNatural) {
            let as = av == null ? '' : String(av);
            let bs = bv == null ? '' : String(bv);
            if (as === '' && bs !== '') return 1;
            if (as !== '' && bs === '') return -1;
            let cmp = as.localeCompare(bs, undefined, { numeric: true, sensitivity: 'base' });
            if (cmp === 0) return 0;
            return secOrder === 'asc' ? cmp : -cmp;
          }
          if (av < bv) return secOrder === 'asc' ? -1 : 1;
          if (av > bv) return secOrder === 'asc' ? 1 : -1;
          return 0;
        });

        this.initialInventory = inList.concat(outList);
        return;
      }

      if(payload.field === 'make (custom)') {
        let uniqueMakes = this.initialInventory.map(item => item.make).filter((value, index, self) => self.indexOf(value) === index);
        let makesOrder = this.gutembergOptions.sort_makes;
        
        makesOrder = this.arrayUnique(makesOrder.concat(uniqueMakes)); 
        makesOrder = makesOrder.map(element => { return element.toLowerCase(); });

        const numericFields = ['year', 'price', 'cashprice', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];

        const SortingPrioritize = (PrioList = [], secondaryField = null, secondaryOrder = null) =>
        {
            return (itemA, itemB) => {
            let a = itemA.make;
            let b = itemB.make;
            let aPos = PrioList.indexOf(a.toLowerCase()), bPos = PrioList.indexOf(b.toLowerCase());

            let makeComparison = (aPos>-1 && bPos>-1) ? aPos - bPos
                            : (aPos>-1) ? -1
                            : (bPos>-1) ? +1
                            : a-b;

            // If makes are equal, apply secondary sort
            if (makeComparison === 0 && secondaryField && secondaryOrder && secondaryField !== 'none' && secondaryOrder !== 'none') {
              let valueA = itemA[secondaryField];
              let valueB = itemB[secondaryField];

              // Convert to number if secondary field is numeric
              if (numericFields.includes(secondaryField)) {
                valueA = (valueA === null || valueA === undefined || valueA === '') ? 0 : parseFloat(valueA);
                valueB = (valueB === null || valueB === undefined || valueB === '') ? 0 : parseFloat(valueB);
                valueA = isNaN(valueA) ? 0 : valueA;
                valueB = isNaN(valueB) ? 0 : valueB;
              }

              // Special handling for price: move $0 to the end
              if (secondaryField === 'price' || secondaryField === 'cashprice') {
                if (valueA === 0 && valueB !== 0) return 1;  // A is 0, move to end
                if (valueA !== 0 && valueB === 0) return -1; // B is 0, move to end
                if (valueA === 0 && valueB === 0) return 0;  // Both 0, equal
              }

              if (valueA < valueB) {
                return secondaryOrder == 'asc' ? -1 : 1;
              }
              if (valueA > valueB) {
                return secondaryOrder == 'asc' ? 1 : -1;
              }
              return 0;
            }

            return makeComparison;
            }
        }

        this.initialInventory.sort( SortingPrioritize(makesOrder, payload.fieldSecondary, payload.orderSecondary) );

      } else if(payload.field === 'model (custom)') {
        // Get the custom models list (priority models)
        let customModels = this.gutembergOptions.sort_models || [];
        customModels = customModels.map(element => element.toLowerCase());

        const numericFields = ['year', 'price', 'cashprice', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];

        // Helper function to apply secondary sort comparison
        const compareSecondary = (itemA, itemB, secondaryField, secondaryOrder) => {
          if (!secondaryField || !secondaryOrder || secondaryField === 'none' || secondaryOrder === 'none') {
            return 0;
          }

          let valueA = itemA[secondaryField];
          let valueB = itemB[secondaryField];

          // Convert to number if secondary field is numeric
          if (numericFields.includes(secondaryField)) {
            valueA = (valueA === null || valueA === undefined || valueA === '') ? 0 : parseFloat(valueA);
            valueB = (valueB === null || valueB === undefined || valueB === '') ? 0 : parseFloat(valueB);
            valueA = isNaN(valueA) ? 0 : valueA;
            valueB = isNaN(valueB) ? 0 : valueB;
          }

          // Special handling for price: move $0 to the end
          if (secondaryField === 'price' || secondaryField === 'cashprice') {
            if (valueA === 0 && valueB !== 0) return 1;
            if (valueA !== 0 && valueB === 0) return -1;
            if (valueA === 0 && valueB === 0) return 0;
          }

          if (valueA < valueB) {
            return secondaryOrder == 'asc' ? -1 : 1;
          }
          if (valueA > valueB) {
            return secondaryOrder == 'asc' ? 1 : -1;
          }
          return 0;
        };

        const SortingPrioritize = (customModelsList, secondaryField, secondaryOrder) => {
          return (itemA, itemB) => {
            const aModel = itemA.model.toLowerCase();
            const bModel = itemB.model.toLowerCase();
            const aIsCustom = customModelsList.includes(aModel);
            const bIsCustom = customModelsList.includes(bModel);

            // If one is custom and the other is not, custom comes first
            if (aIsCustom && !bIsCustom) return -1;
            if (!aIsCustom && bIsCustom) return 1;

            // Both are in the same group (both custom or both non-custom)
            // Apply secondary sort within the group
            return compareSecondary(itemA, itemB, secondaryField, secondaryOrder);
          };
        };

        this.initialInventory.sort(SortingPrioritize(customModels, payload.fieldSecondary, payload.orderSecondary));

      } else if (payload.field === 'price') {
        const asc = payload.order === 'asc';
        const numericFields = ['year', 'price', 'cashprice', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];

        const toNumber = (val) => {
          if (val == null) return 0;
          const n = parseFloat(String(val).replace(/[^\d.-]/g, ''));
          return Number.isFinite(n) ? n : 0;
        };

        this.initialInventory.sort(withLocationPriority((a, b) => {
          const pa = toNumber(a[payload.field]);
          const pb = toNumber(b[payload.field]);

          const aIsZero = pa <= 0;
          const bIsZero = pb <= 0;

          if (aIsZero !== bIsZero) return aIsZero ? 1 : -1;

          // Primary comparison
          let primaryComparison = 0;
          if (asc) {
            primaryComparison = pa - pb;
          } else {
            primaryComparison = pb - pa;
          }

          // If prices are equal, apply secondary sort
          if (primaryComparison === 0 && payload.fieldSecondary && payload.orderSecondary && payload.fieldSecondary !== 'none' && payload.orderSecondary !== 'none') {
            let valueA = a[payload.fieldSecondary];
            let valueB = b[payload.fieldSecondary];

            // Convert to number if secondary field is numeric
            if (numericFields.includes(payload.fieldSecondary)) {
              valueA = (valueA === null || valueA === undefined || valueA === '') ? 0 : parseFloat(valueA);
              valueB = (valueB === null || valueB === undefined || valueB === '') ? 0 : parseFloat(valueB);
              valueA = isNaN(valueA) ? 0 : valueA;
              valueB = isNaN(valueB) ? 0 : valueB;
            }

            // Special handling for price: move $0 to the end (secondary)
            if (payload.fieldSecondary === 'price' || payload.fieldSecondary === 'cashprice') {
              if (valueA === 0 && valueB !== 0) return 1;  // A is 0, move to end
              if (valueA !== 0 && valueB === 0) return -1; // B is 0, move to end
              if (valueA === 0 && valueB === 0) return 0;  // Both 0, equal
            }

            if (valueA < valueB) {
              return payload.orderSecondary == 'asc' ? -1 : 1;
            }
            if (valueA > valueB) {
              return payload.orderSecondary == 'asc' ? 1 : -1;
            }
          }

          return primaryComparison;
        }));

      } else {
        this.initialInventory.sort((a, b) => {
          // Primary sort
          var nameA = a[payload.field];
          var nameB = b[payload.field];

          // Convert to number if field is numeric
          var numericFields = ['year', 'price', 'cashprice', 'mileage', 'numberofpics', 'ininventory'];
          if (numericFields.includes(payload.field)) {
            nameA = (nameA === null || nameA === undefined || nameA === '') ? 0 : parseFloat(nameA);
            nameB = (nameB === null || nameB === undefined || nameB === '') ? 0 : parseFloat(nameB);
            nameA = isNaN(nameA) ? 0 : nameA;
            nameB = isNaN(nameB) ? 0 : nameB;
          }

          // Special handling for price asc: move $0 to the end (primary sort)
          if ((payload.field === 'price' || payload.field === 'cashprice') && payload.order === 'asc') {
            if (nameA === 0 && nameB !== 0) return 1;  // A is 0, move to end
            if (nameA !== 0 && nameB === 0) return -1; // B is 0, move to end
            // Both 0 or both non-zero, continue with normal comparison
          }

          if (nameA < nameB) {
            return payload.order == 'asc' ? -1 : 1;
          }
          if (nameA > nameB) {
            return payload.order == 'asc' ? 1 : -1;
          }

          // Values are equal, apply secondary sort if provided
          if (payload.fieldSecondary && payload.orderSecondary && payload.fieldSecondary !== 'none' && payload.orderSecondary !== 'none') {
            var nameASecondary = a[payload.fieldSecondary];
            var nameBSecondary = b[payload.fieldSecondary];

            // Convert to number if secondary field is numeric
            if (numericFields.includes(payload.fieldSecondary)) {
              nameASecondary = (nameASecondary === null || nameASecondary === undefined || nameASecondary === '') ? 0 : parseFloat(nameASecondary);
              nameBSecondary = (nameBSecondary === null || nameBSecondary === undefined || nameBSecondary === '') ? 0 : parseFloat(nameBSecondary);
              nameASecondary = isNaN(nameASecondary) ? 0 : nameASecondary;
              nameBSecondary = isNaN(nameBSecondary) ? 0 : nameBSecondary;
            }

            // Special handling for price: move $0 to the end (secondary sort)
            if (payload.fieldSecondary === 'price' || payload.fieldSecondary === 'cashprice') {
              if (nameASecondary === 0 && nameBSecondary !== 0) return 1;  // A is 0, move to end
              if (nameASecondary !== 0 && nameBSecondary === 0) return -1; // B is 0, move to end
              if (nameASecondary === 0 && nameBSecondary === 0) return 0;  // Both 0, equal
            }

            if (nameASecondary < nameBSecondary) {
              return payload.orderSecondary == 'asc' ? -1 : 1;
            }
            if (nameASecondary > nameBSecondary) {
              return payload.orderSecondary == 'asc' ? 1 : -1;
            }
          }

          return 0;
        });
      }

      if (this.lastFilterPayload) {
        this.inventory = EventBus.postFilterInventory(this.initialInventory, this.lastFilterPayload);
      }
    },
    arrayUnique(array) {
      var a = array.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i] === a[j])
                  a.splice(j--, 1);
          }
      }
  
      return a;
    },
    goToCompare(id, lang) {
      let compare;
      if (!localStorage.compare) {
        var Obj = {
          ids: [id],
        };
        localStorage.setItem('compare', JSON.stringify(Obj));
      } else {
        compare = JSON.parse(localStorage.compare);

        if (compare.ids.indexOf(id) == -1) compare.ids.push(id);

        if (compare.ids.length > 4) {
          compare.ids.splice(0, 1);
        }
        localStorage.compare = JSON.stringify(compare);
      }

      compare = JSON.parse(localStorage.compare);

      let urlIds = [];
      var j = 0;
      for (var i = compare.ids.length - 1; i >= 0; i--) {
        if (j >= 4) break;

        urlIds.push(compare.ids[i]);
        j++;
      }

      var slug = '/compare/';
      if (lang == 'fr-CA')
        slug = '/comparer/'
      window.location.href = slug + '?vehicles=' + urlIds.join('|');
    },
    goToComparePage(id, lang){
      let urlIds = [];
      var j = 0;
      for (var i = compare.ids.length - 1; i >= 0; i--) {
        if (j >= 4) break;

        urlIds.push(compare.ids[i]);
        j++;
      }
      
      var slug = '/compare/';
      if (lang == 'fr-CA')
        slug = '/comparer/'
      window.location.href = slug + '?vehicles=' + urlIds.join('|');
    },
    filterInventory(payload) {
      // Sticky VIN filter: re-inject the URL ?filter_vin= value into every payload
      // because the sidebar filter emits payloads without VIN. Read live from
      // window.location instead of urlParams so a clear() that strips filter_vin
      // from the URL is honored (urlParams is captured at render and never updates).
      if (!payload.vin) {
        try {
          var urlVin = new URLSearchParams(window.location.search).get('filter_vin') || '';
          if (urlVin) payload.vin = urlVin;
        } catch (e) {}
      }
      this.lastFilterPayload = payload;
      this.inventory = EventBus.postFilterInventory(this.initialInventory, payload);
      this.goToPage(payload.page);

      // The append counter follows the page the filter reset to; otherwise the
      // next "View More" / scroll append jumps to the page reached before filtering.
      this.i = this.currentPage;

      // The scroll observer only calls loadNextPage when a sentinel's visibility
      // changes. If the footer was already in view when the inventory arrived
      // (its first callback bailed on an empty list) or a filter shrank the list
      // under it, no further event comes and the SRP stalls on the first page.
      if (this.lMore)
        this.$nextTick(() => this.loadNextPage());
    },
    string_contains_value(text, filter) {
      var array = filter.toLowerCase().split("_");
      var total_words = array.length;
      var vehicle = text.split(' ').map((item) => {
        return item.toLowerCase();
      })
      var total_coincidences = 0;
      array.forEach((item) => {
        var total_i = vehicle.filter((span) => {
          return span.includes(item);
        }).length;

        var total_p = vehicle.filter((span) => {
          return span.replace(/-/g, '').includes(item.replace(/-/, ''));
        }).length;

        if (total_i > 0 || total_p > 0)
          total_coincidences++;
      })

      if (total_words == total_coincidences) {
        return true;
      }
      else {
        return false;
      }
    },
    isEmpty(val) {
      return (val === undefined || val == null || val.length <= 0) ? true : false;
    },
    goToPage(page) {
      this.currentPage = page;

      if(this.currentPage * this.ipp < this.inventory.length)
        this.displayMoreBtn = true;
      else
        this.displayMoreBtn = false;

      // The manual lazy-loading pass that used to run here queried
      // ".vehicle-card .main-img", which matches nothing: cards render as
      // ".content__vehicle-car". It was building (and never disconnecting) an
      // IntersectionObserver per page over an empty list. The card templates
      // already ship loading="lazy" with a real src, so the browser handles it.
    },
  },
  computed: {
    // LBT-1462 (grouped mode): assign a listing-insert image to card positions.
    // Returns a map { count -> entry } where count is the 1-based card index.
    // At each qualifying position (count % offset === 0) we rotate a cursor
    // through the ordered entries and place the next one whose condition scope
    // ('both' or matching the card's New/Used) fits — so a skipped image never
    // leaves an empty slot; the next matching one fills it and the skipped ones
    // come back around on a later matching card. Only empty when NO entry can
    // match that card's condition. repeat = number of full cycles (0 = until end).
    groupedListingMap() {
      var map = {};
      var cfg = this.listingConfig || {};
      if (cfg.mode !== 'grouped') return map;
      var entries = Array.isArray(this.listingEntries) ? this.listingEntries : [];
      if (!entries.length) return map;
      var offset = parseInt(cfg.offset, 10) || 0;
      if (offset <= 0) return map;

      // LBT-1462 Round 3: image groups carry a `start` (card # of the first inserted
      // image), then repeat every `offset`. The legacy/global config has no `start`,
      // so fall back to `offset` — i.e. first insert at `offset` — keeping the prior
      // behaviour (positions offset, 2*offset, 3*offset…) exactly.
      var start = parseInt(cfg.start, 10);
      if (!start || start <= 0) start = offset;

      var groupCount = entries.length;
      var repeat = parseInt(cfg.repeat, 10) || 0;
      var maxPlacements = repeat > 0 ? repeat * groupCount : Infinity;

      var list = this.inventoryPage || [];
      var cursor = 0;
      var placements = 0;
      for (var i = 0; i < list.length; i++) {
        var count = i + 1;
        if (count < start || (count - start) % offset !== 0) continue;
        if (placements >= maxPlacements) break;
        var cond = (list[i] && list[i].condition ? String(list[i].condition) : '').toLowerCase();
        for (var tries = 0; tries < groupCount; tries++) {
          var e = entries[cursor % groupCount];
          cursor++;
          if (e && (e.condition === 'both' || e.condition === cond)) {
            map[count] = e;
            placements++;
            break;
          }
        }
      }
      return map;
    },
    inventoryPage() {
        //Obtaining model selected from NewAdvancedSearch or Gutenberg Options, for SRP Insert Image
        if(this.imagesForModels){
            let actualUrl = window.location.pathname.split("/");
            if(actualUrl.indexOf("model") >= 0){
                var modelS = actualUrl[actualUrl.indexOf("model")+1];
                var modelSelectedSplit = modelS.split(",");
                    if(this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ] !== undefined)
                        this.modelSelected = this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ];
                    else
                        this.modelSelected = null;
            }
            else if (this.gutembergOptions["model"] !== "all") {
              var model_name = this.gutembergOptions["model"]
              model_name = model_name.replace(/\s+/g, '-').toLowerCase();
              this.modelSelected = this.imagesForModels[this.gutembergOptions["model"].toLowerCase()] || this.imagesForModels[model_name] ;
            }
            else
                this.modelSelected = null;
        }else
            this.modelSelected = null;
    
      // When multiple inventories exist, show all inventory without pagination
      // This prevents pagination conflicts when multiple inventories are on the same page
      if (EventBus.inventoryInstanceCount > 1) {
        return this.inventory;
      }

      var base = this.currentPage - 1;
      if (!this.lMore && !this.lMoreBtn){
        return this.inventory.slice(base * this.ipp, (this.currentPage * this.ipp));
      }
      else {
        return this.inventory.slice(0, (this.currentPage * this.ipp));
      }

    },
    computedParams() {
      var globalRange = [0, 9999999999999];
      var mileageRange = (this.urlParams.mileage) ?
        [this.urlParams.mileage.since, this.urlParams.mileage.to] :
        globalRange;
      var priceRange = (this.urlParams.price) ?
        [this.urlParams.price.since, this.urlParams.price.to] :
        globalRange;
      var dryweightRange = (this.urlParams.dryweight) ? 
        [this.urlParams.dryweight.since, this.urlParams.dryweight.to] : 
      globalRange;
      var grossweightRange = (this.urlParams.grossweight) ? 
        [this.urlParams.grossweight.since, this.urlParams.grossweight.to] : 
      globalRange;
      var carprooflinkRange = (this.urlParams.carprooflink) ? 
        [this.urlParams.carprooflink.since, this.urlParams.carprooflink.to] : 
      globalRange;
      var paymentRange = (this.urlParams.payment) ?
        [this.urlParams.payment.since, this.urlParams.payment.to] :
      globalRange;
      var sleepcapacityRange = (this.urlParams.sleepcapacity) ? 
        [this.urlParams.sleepcapacity.since, this.urlParams.sleepcapacity.to] : 
      globalRange;

      var payload = {
        page: this.currentPageProp,
        stockNumber: this.urlParams.stocknumber || "",
        vin: this.urlParams.vin || "",
        dryweightRange,
        grossweightRange,
        sleepcapacityRange,
        mileageRange,
        priceRange,
        carprooflinkRange,
        paymentRange,
        minPrice: globalRange[0],
        maxPrice: globalRange[1],
        minMileage: globalRange[0],
        maxMileage: globalRange[1],
        minDryweight: globalRange[0],
        maxDryweight: globalRange[1],
        minGrossweight: globalRange[0],
        maxGrossweight: globalRange[1],
        minSleepcapacity: globalRange[0],
        maxSleepcapacity: globalRange[1],
        minCarprooflink: globalRange[0],
        maxCarprooflink: globalRange[1],
        minPayment: globalRange[0],
        maxPayment: globalRange[1],
        filterValue: this.urlParams.filter || "",
        paymentFrequency: this.paymentFrequency || "",
        selected: {
          condition: this.urlParams.conditions || [],
          year: this.urlParams.years || [],
          make: this.urlParams.makes || [],
          lot: this.urlParams.lots || [],
          model: this.urlParams.models || [],
          type: this.urlParams.types || [],
          subtype: this.urlParams.subtypes || [],
          productline: this.urlParams.productlines || [],
          outsidelength: this.urlParams.outsidelengths || [],
          floorplan: this.urlParams.floorplans || [],
          trim: this.urlParams.trims || [],
          colour: this.urlParams.color || [],
          bodystyle: this.urlParams.bodystyles || [],
          transmission: this.urlParams.transmissions || [],
          drivetrain: this.urlParams.drivetrains || [],
          boxsize: this.urlParams.boxsizes || [],
          status: this.urlParams.status || [],
          salepending: this.urlParams.salependings || [],
          demo: this.urlParams.demos || [],
          asis: this.urlParams.asiss || [],
          certified: this.urlParams.certifieds || [],
          special: this.urlParams.specials || [],
          stock: this.urlParams.stocks || [],
          enginedisplacement: this.urlParams.enginedisplacements || [],
          package: this.urlParams.package || [],
          engine: this.urlParams.engines || [],
          // LBT-1602 (H8/H9): parser emits `locations`, plural. Reading the
          // singular key left the location filter out of the filtering payload
          // on a direct load, which is what made srp_total_results report the
          // unfiltered-by-location count while the page rendered the correct
          // one. See the matching comment in new-advanced-search-hybrid.
          location: this.urlParams.locations || this.urlParams.location || [],
          feature: this.urlParams.searchables || [],
          fueltype: this.urlParams.fueltypes || [],
          seat: this.urlParams.seats || [],
        },
      }

      return payload;
    },
    inventoryZero(){
      return this.inventory.length <= 0;
    },
    autoLoadCapReached() {
      return this.currentPage * this.ipp >= SCROLL_AUTO_LOAD_MAX_ITEMS;
    },
    // Whether the infinite-scroll spinner row exists at all. It is kept mounted
    // for the whole auto-loading phase and only its opacity changes per page, so
    // appending never alters page height — see the note in the layout.
    showAppendLoader() {
      return !!this.lMore && !this.autoLoadCapReached && this.displayMoreBtn;
    },
    // Shown in classic "load more button" mode, and in infinite-scroll mode
    // once auto-appending has been capped, so the rest of the results stay
    // reachable without the page growing on its own.
    displayLoadMoreBtn() {
      if (!this.displayMoreBtn) return false;
      if (this.lMoreBtn) return true;
      return this.lMore && this.autoLoadCapReached;
    },
    hasMultipleInventories() {
      return EventBus.inventoryInstanceCount > 1;
    }
  }
}